<template>
  <div class="Unpaid">
    <div class="page-title">{{title}}</div>
    <div>
      <ATable
        ref="table"
        v-loading="loading"        
        class="no-pointer"        
        max-height="732px"  
        :placeholder="placeHolder"
        :search_field="search_field"
        :summaryTitleColumnIndex="2"
        :summaryFields="summaryFields"
        :data="sortedItems"
        show-summary
        hide-button-insert
        hide-pagination
        border
        @sort-change="handleSortChange"
      >
        <div slot="search">
          <div class="inline">
            <APeriodSelector 
              ref="period" 
              :value="search_period" 
              hide-select
              @change="handleChangePeriod" 
            />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
            >검색(F5)</el-button>
          </div>
        </div>
        <el-table-column
          type="index"
          label="No"
          :index="handleIndex"
          :width="$width.indexw"
        />
        <el-table-column 
          prop="name" 
          label="거래처명"
          width="120"
          show-overflow-tooltip 
          sortable="custom"
        />
        <el-table-column 
          prop="owner" 
          label="대표자" 
          width="85" 
          sortable="custom"
          show-overflow-tooltip 
        />
        <el-table-column 
          prop="tel" 
          label="전화" 
          width="110" 
          show-overflow-tooltip 
        />
        <el-table-column 
          prop="last_balance"
          label="이월금"
          class-name="cell-number"
          width="100"       
          sortable="custom" 
          :formatter="util.numberFormat"   
        />
        <el-table-column 
          prop="sum_income"
          label="기간매입"
          class-name="cell-number"
          width="100" 
          sortable="custom"
          :formatter="util.numberFormat"
        />
        <el-table-column 
          prop="sum_expense"
          label="기간결제"
          class-name="cell-number"
          width="100" 
          sortable="custom"
          :formatter="util.numberFormat"
        />
        <el-table-column 
          prop="balance"
          label="잔액"
          class-name="cell-number"
          width="100" 
          sortable="custom"
          :formatter="util.numberFormat"
        />
        <el-table-column 
          prop="desc"
          label="비고"
          show-overflow-tooltip 
        />
        <el-table-column 
          prop="last_expense_date"
          label="최근결제"
          width="110"
          sortable="custom"
        />
        <el-table-column 
          prop="last_income_date"
          label="최근매입"
          width="110"
          sortable="custom"
        />
        <el-table-column 
          prop="recent_income"
          label="3개월간매입"
          class-name="cell-number"
          width="120" 
          sortable="custom"
          :formatter="util.numberFormat"
        />
      </ATable>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { sort_items } from "@/common/mixins/sort_items";

export default {
  name: "Unpaid",
  mixins: [sort_items],
  data() {
    return {
      title: this.$t('title.unpaid'),
      placeHolder: "거래처명, 비고",
      search_field: ["name", "desc"],
      summaryFields: ["last_balance", "sum_income", "sum_expense", "balance", "recent_income"],
      search_period: {value: '1w'},
      period: {},
      loading: false,
      items: [],
    };
  },
  computed: {
    ...mapGetters(["table_customer"]),
  },
  methods: {
    loadData() {
      this.loading = true;
      this.api.statExpense(this.period).then(res => {        
        if (res.error !== this.system.noError) {
          this.loading = false;
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items = this.organizeData(res.data);
        this.loading = false;
      });
    },
    organizeData(items) {
      items.forEach(item => {
        let c = this.table_customer.find(c => c.id === item.id);
        if (!c) { return true; }
        item.name = c.name;
        item.owner = c.owner;
        item.tel = c.tel;
      })
      return items;
    },    
    handleChangePeriod(value) {
      this.period = value;
      this.handleClickSearch();
    },
    handleClickSearch() {
      if (!this.period.valid) { return; }
      this.loadData();
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    }, 
  },
};
</script>
